import { cn } from "@/lib/utils";

export const STATUSES = [
  { value: "nou", label: "Nou" },
  { value: "in_lucru", label: "În lucru" },
  { value: "rezolvat", label: "Rezolvat" },
];

export const PRIORITIES = [
  { value: "scazuta", label: "Scăzută" },
  { value: "medie", label: "Medie" },
  { value: "ridicata", label: "Ridicată" },
  { value: "urgenta", label: "Urgentă" },
];

const STATUS_CLS = {
  nou: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30",
  in_lucru: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30",
  rezolvat: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
};

const PRIO_CLS = {
  scazuta: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/30",
  medie: "bg-cyan-500/10 text-cyan-700 dark:text-cyan-400 border-cyan-500/30",
  ridicata: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/30",
  urgenta: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/40",
};

export const labelOf = (list, v) => list.find((x) => x.value === v)?.label || v;

const pill = "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold";

export const StatusBadge = ({ status, ...p }) => (
  <span className={cn(pill, STATUS_CLS[status])} {...p}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {labelOf(STATUSES, status)}
  </span>
);

export const PriorityBadge = ({ priority, ...p }) => (
  <span className={cn(pill, PRIO_CLS[priority])} {...p}>
    <span className={cn("h-1.5 w-1.5 rounded-full bg-current", priority === "urgenta" && "animate-pulse")} />
    {labelOf(PRIORITIES, priority)}
  </span>
);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("ro-RO", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

export const fmtMoney = (n) => `${Number(n || 0).toLocaleString("ro-RO", { maximumFractionDigits: 2 })} lei`;

export const waLink = (phone) => {
  let d = (phone || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  else if (d.startsWith("0")) d = `4${d}`;
  return `https://wa.me/${d}`;
};
